module.exports = __webpack_public_path__ + "img/access.220d5945.svg";